import { render, staticRenderFns } from "./RegistroConvocatoriaDialogComponent.vue?vue&type=template&id=3b997977"
import script from "./RegistroConvocatoriaDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistroConvocatoriaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports